import { baseApi } from '@shared/api';
import { IGenerationProgress } from '../model';
import { ISenderProgress } from '@entities/sender-state/model';

export const generationStateApi = baseApi.injectEndpoints({
  endpoints: build => ({
    addExcelFile: build.mutation<boolean, { formData: FormData; endpoint: string }>({
      query: ({ formData, endpoint }) => ({
        url: `/invoices/${endpoint}`,
        method: 'POST',
        body: formData,
      }),
      transformResponse: () => true,
      transformErrorResponse: () => false,
    }),
    resetGenerationState: build.mutation<boolean, string>({
      query: id => ({
        url: 'invoices/reset',
        method: 'PUT',
        body: {
          userId: id,
        },
      }),
      transformResponse: () => true,
      transformErrorResponse: () => false,
    }),
    getGenerationProgress: build.query<IGenerationProgress, string>({
      query: id => ({
        url: `/invoices/generation/${id}/state`,
      }),
    }),
    getSendingProgress: build.query<ISenderProgress, string>({
      query: id => ({
        url: `emails/sending/${id}/state`,
      }),
    }),
    beginGeneration: build.mutation<string, { userId: string; prefix: string }>({
      query: body => ({
        url: '/invoices/generation',
        method: 'POST',
        body,
      }),
      transformResponse: (response: { stateId: string }) => response.stateId,
    }),
    downloadInvoices: build.query<void, string>({
      query: id => ({
        url: `/invoices/download/${id}/state`,
      }),
    }),
    sendEmails: build.mutation<string, { id: string; subject: string }>({
      query: ({ id, subject }) => ({
        url: `/invoices/state/${id}/send-emails`,
        method: 'POST',
        body: {
          subject,
        },
      }),
    }),
  }),
});

export const {
  useBeginGenerationMutation,
  useResetGenerationStateMutation,
  useSendEmailsMutation,
  useLazyGetGenerationProgressQuery,
  useGetGenerationProgressQuery,
  useLazyGetSendingProgressQuery,
  useGetSendingProgressQuery,
  useLazyDownloadInvoicesQuery,
  useAddExcelFileMutation,
} = generationStateApi;
